import * as actions from 'redux/actions/keywordPages.actions'

const initialState = {}

const updatePages = (pagesList, amendsList) => {
  return pagesList.map(page => {
    const amendPage = amendsList.find(item => item.id === page.id)
    if (amendPage) {
      return {
        ...page,
        attributes: {
          ...page.attributes,
          ...amendPage.attributes
        }
      }
    }
    return page
  })
}

const domainPage = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getPagesSuccess.type:
      return { ...state, pages: payload.pages }
    case actions.getPagesChangesSuccess.type:
      return { ...state, pages: updatePages(state.pages, payload.pages) }
    default:
      return state
  }
}

export default domainPage
